import React from "react";
import Back from "../../Assets/back_icon.png";
import styles from "./back.module.css";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.back}>
      <img style={{ height: "10px", width: "12px" }} src={Back} alt="back" />
      Back
    </div>
  );
};

export default BackButton;
